export const productDetailsService = (response, context) => {
  let setup = () => {
    return {};
  };

  if (response.data.partnerName === 'ace') {
    setup = require('@/components/Substore/Partners/ace/productDetailsHooksSetup.js').default;
  }

  const hooks = setup(response, context);

  const proxy = (action, cb) => {
    if (hooks[action]) {
      hooks[action](cb);
    } else {
      cb();
    }
  };

  return { proxy, ...hooks };
};

export const errorService = (context, data) => {
  let setup = () => {
    return {};
  };

  if (context.$store.getters['system/isPageContextUnbarring']) {
    setup = require('@/components/Error/HooksSetup/unbarring.js').default;
  } else if (context.$store.getters['system/isPageContextCita']) {
    setup = require('@/components/Error/HooksSetup/cita.js').default;
  } else if (
    context?.error?.data?.args?.code === 'PRODUCT_NOT_BOOKABLE_BECAUSE_EXCLUDED_SUBTEMPID' ||
    context.code === 'SUBSTORE_ERROR_FATAL:PRODUCT_NOT_BOOKABLE_BECAUSE_EXCLUDED_SUBTEMPID'
  ) {
    setup = require('@/components/Error/HooksSetup/excludedBy.js').default;
  } else if (context.$route.query.refurl || context.$store.state.system.refUrl) {
    setup = require('@/components/Error/HooksSetup/refUrl.js').default;
  }

  const hooks = setup(context, data);

  const proxy = (action, cb) => {
    if (hooks[action]) {
      hooks[action](cb);
    } else {
      cb();
    }
  };

  return { proxy, ...hooks };
};

export default { productDetailsService, errorService };
